const Button = ({ page, loading }) => {
  return (
    <button
      className={`btn-green focus:border-none focus:outline-none w-full mb-4 !h-[56px] ${loading ? "opacity-50 cursor-not-allowed" : ""}`}
      type="submit"
      disabled={loading}
    >
      {loading ? "Yükleniyor..." : page === "giris"
        ? "Giriş yap"
        : page === "kariyer_bilgileri"
        ? "Kaydımı Tamamla"
        : page === "sifre-yenileme"
        ? "Gönder"
        : page === "yeni-sifre-belirle"
        ? "Onayla"
        : "Devam"}
    </button>
  );
};

export default Button;